import React, { useEffect, useState } from "react";
import TableHeader from "../../common/MagicPageHeader";
import Header from "../../common/MagicTableHeader";
import MagicTable from "../../common/MagicTable";
import DownloadToXlsxFile from "../../../helper/DownloadToXlsxFile";
import ImageComponent from "../../mui/Image";
import { useFetchDropOutReportsQuery } from "../../../store/apis/reportsApis";

interface TabCategory {
  id: number;
  name: string;
  code: string;
}

interface DropOutTableProps {
  selectedTab: TabCategory | null;
  magicPageHeaderBtn: {
    text: string;
    variant: string;
    startIcon: React.ReactNode;
    onClick: () => void;
    sx: Record<string, string>;
  }[];
  magicTableHeaderBtn: any[];
  params:any;
  isInvalidSearch: boolean;
  onPaginationChange: (pageNo: number) => void;
  onSearch: (searchTerm: string) => void;
}

const DropOutTable: React.FC<DropOutTableProps> = ({
  selectedTab,
  magicTableHeaderBtn,
  params,
  isInvalidSearch,
  onPaginationChange,
  onSearch,
}) => {
  const [downloadParams, setDownloadParams] = useState<any>(null);
  const [downloadTrigger, setDownloadTrigger] = useState(false);
  const columns = [
    {
      field: "centre",
      headerName: "Centre",
      flex: 1,
      minWidth: 200,
      sortable: true,
    },
    {
      field: "funder",
      headerName: "Funder",
      flex: 1,
      minWidth: 150,
      sortable: true,
    },
    {
      field: "batchId",
      headerName: "Batch ID",
      flex: 1,
      minWidth: 150,
      sortable: true,
    },
    {
      field: "batchStartDate",
      headerName: "Batch start date",
      flex: 1,
      minWidth: 150,
      sortable: true,
      type: "date",
    },
    {
      field: "batchEndDate",
      headerName: "Batch end date",
      flex: 1,
      minWidth: 150,
      sortable: true,
      type: "date",
    },
    {
      field: "totalNumberOfYPsEnrolled",
      headerName: "Total number of YP's enrolled in the batch",
      flex: 1,
      minWidth: 200,
      sortable: true,
    },
    {
      field: "totalNumberOfYPsDroppedOut",
      headerName: "Total number of YP's dropped out",
      flex: 1,
      minWidth: 200,
      sortable: true,
    },
  ];

  const {
    data: fetchedReports = {
      reports: [],
      totalReports: 0,
    },
    isLoading,
  } = useFetchDropOutReportsQuery(params);
  const { data: downloadData,isLoading: downloadLoading } = useFetchDropOutReportsQuery(downloadParams, {
    skip: !downloadParams,
  });
  const handleDownload = () => {
    const downloadPayload = {
      ...params,
      pageNo: "1",
      pageSize: fetchedReports?.totalReports || "10",
    };
    setDownloadParams(downloadPayload);
    setDownloadTrigger(true);  
  };
  useEffect(()=>{ 
    if (downloadData && downloadTrigger) {
  const sheetData = [
    [
      "Centre",
      "Funder",
      "Batch ID",
      "Batch Start Date",
      "Batch End Date",
      "Total YPs Enrolled",
      "Total YPs Dropped Out",
    ],
    ...downloadData?.reports.map((dropout: any) => [
      dropout.centre || "-",
      dropout.funder || "-",
      dropout.batchId || "-",
      dropout.batchStartDate || "-",
      dropout.batchEndDate || "-",
      dropout.totalYPsEnrolled || "-",
      dropout.totalYPsDroppedOut || "-",
    ]),
  ];

  DownloadToXlsxFile({
    fileNamePrifix: "Drop-Out-Report",
    sheetData,
  });
  setDownloadTrigger(false);  
}
}, [downloadData, downloadTrigger]);  

  const magicPageHeaderBtn = [
    {
      text: "Download",
      variant: "outlined",
      startIcon: (
        <ImageComponent src="/assets/images/login/exportIcon.svg" alt="ExportIcon" />
      ),
      onClick: handleDownload,
      loading: downloadLoading,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        color: "black",
      },
    },
  ];
  const totalPages = Math.max(1, Math.ceil((fetchedReports?.totalReports || 0) /10));
  return (
    <>
      <TableHeader
        title={`${selectedTab?.name || "Drop Out"} Report`}
        subTitle="Here you can view the report with all the details."
        buttons={magicPageHeaderBtn}
        chipLabel={`${ fetchedReports?.totalReports || 0} entries`}
      />
      <Header
        buttons={magicTableHeaderBtn}
        onSearchfieldChange={(value) => onSearch(String(value))}
        isInvalidSearch={isInvalidSearch}
      />
      <MagicTable
        columns={columns}
        rows={fetchedReports?.reports} 
        loading={isLoading}
        handlePageChange={(event, pageNo) => onPaginationChange(pageNo)}
        count={totalPages}
        currentPage={parseInt(params?.pageNo) || 1}
        rowCellsSx={{ paddingLeft: "16px", textAlign: "start" }}
        headerSx={{
          paddingLeft: "16px",
          textAlign: "start",
          fontWeight: 600,
          color: "#242424",
          padding: "13px 16px",
        }}
        tableSx={{ minHeight: "300px", width: "100%" }}
        sx={{
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#DADADA",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 550,
            fontSize: "14px",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },}}
      />
    </>
  );
};

export default DropOutTable;